import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: "/login",
    method: "post",
    data: data,
  });
};

AuthService.logout = function () {
  return fetch({
    url: "/logout",
    method: "post",
  });
};

AuthService.getMe = function () {
  return fetch({
    url: "/me",
    method: "get",
  });
};

AuthService.sendEmail = function (data) {
  return fetch({
    url: "/password/reset",
    method: "post",
    data: data,
  });
};

AuthService.confirmEmail = function (data) {
  return fetch({
    url: "/password/reset/confirm",
    method: "post",
    data: data,
  });
};

AuthService.changePassword = function (data) {
  return fetch({
    url: "/password/change",
    method: "post",
    data: data,
  });
};

AuthService.inviteConfirm = function (data) {
  return fetch({
    url: "/invite/confirm",
    method: "post",
    data: data,
  });
};

AuthService.refreshToken = function (refreshToken) {
  return fetch({
    url: "/refresh",
    method: "post",
    data: { refresh: refreshToken },
  });
};

export default AuthService;
